import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_menu-projects",
  "use": "svg_menu-projects-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 21\" id=\"svg_menu-projects\"><path d=\"M0 2h8a2 2 0 1 1 4 0h8v2h-1v11h-5.75L15 21h-2l-1.75-6h-2.5L7 21H5l1.75-6H1V4H0V2zm3 2v9h14V4H3z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol